import {
  hasCustomEndpointConfig,
  getEndpoints,
  selectEndpoint,
  buildUrl,
} from './network.helper';

interface NetworkUrls {
  baseUrl?: string;
  induswinUrl?: string;
  sportsUrl?: string;
  imApiUrl?: string;
  quick3dUrl?: string;
  lqiUrl?: string;
  loiUrl?: string;
  racecarUrl?: string;
}

/**
 * 根据环境配置适配URL，如果不需要多域名则返回原始URLs
 */
export function adaptNetworkUrls(
  env: string,
  originalUrls: NetworkUrls,
  fallbackBaseUrl: string,
): NetworkUrls {
  // 如果没有自定义端点配置，直接返回原始URLs
  if (!hasCustomEndpointConfig(env)) {
    return originalUrls;
  }

  try {
    const baseEndpoints = getEndpoints('base', env, fallbackBaseUrl);
    const ltapiEndpoints = getEndpoints(
      'lt',
      env,
      fallbackBaseUrl,
      originalUrls.induswinUrl,
    );
    const sportsEndpoints = getEndpoints(
      'sports',
      env,
      fallbackBaseUrl,
      originalUrls.sportsUrl,
    );
    const imEndpoints = getEndpoints(
      'im',
      env,
      fallbackBaseUrl,
      originalUrls.imApiUrl,
    );
    const quick3dEndpoints = getEndpoints(
      'quick3d',
      env,
      fallbackBaseUrl,
      originalUrls.quick3dUrl,
    );
    const lqiEndpoints = getEndpoints(
      'lqi',
      env,
      fallbackBaseUrl,
      originalUrls.lqiUrl,
    );
    const loiEndpoints = getEndpoints(
      'loi',
      env,
      fallbackBaseUrl,
      originalUrls.loiUrl,
    );

    const selectedSportsEndpoint = selectEndpoint(sportsEndpoints);
    const isUsingSportsEnvVar =
      selectedSportsEndpoint === originalUrls.sportsUrl;

    return {
      baseUrl: buildUrl(selectEndpoint(baseEndpoints)),
      induswinUrl: buildUrl(selectEndpoint(ltapiEndpoints)),
      sportsUrl: buildUrl(
        selectedSportsEndpoint,
        isUsingSportsEnvVar ? undefined : 'sport',
      ),
      imApiUrl: buildUrl(selectEndpoint(imEndpoints)),
      quick3dUrl: buildUrl(selectEndpoint(quick3dEndpoints)),
      lqiUrl: buildUrl(selectEndpoint(lqiEndpoints)),
      loiUrl: buildUrl(selectEndpoint(loiEndpoints)),
      racecarUrl: originalUrls.racecarUrl,
    };
  } catch (error) {
    // 如果多域名逻辑失败，回退到原始URLs
    console.warn('多域名配置失败，使用原始配置:', error);
    return originalUrls;
  }
}
